import React from 'react'
import './Features.scss'
import featureIcon from '../../Images/featureIcon.svg'

function Features() {
  return (
    <div id="features">
        <div className='sectionHeader'>
            <h2 className='sectionTitle'>Features</h2>
            <p className='sectionSubtitle'>An extensive amount of features to ensure the success of members.</p>
        </div>

        <div className="container featureContainer">
          <div className="row row-cols-2 row-cols-md-2 row-cols-lg-3 row-cols-xl-3">
            <div className="col">
              <div className="featureCard">
                <img
                  className="featureIcon"
                  src={featureIcon}
                  alt="Feature Icon"
                />
                <h3>Lightning Fast</h3>
                <p>
                Fully multi-threaded for a blazing fast and reliable experience.
                </p>
              </div>
            </div>
            <div className="col">
              <div className="featureCard">
                <img
                  className="featureIcon"
                  src={featureIcon}
                  alt="Feature Icon"
                />
                <h3>Lightning Fast</h3>
                <p>
                Fully multi-threaded for a blazing fast and reliable experience.
                </p>
              </div>
            </div>
            <div className="col">
              <div className="featureCard">
                <img
                  className="featureIcon"
                  src={featureIcon}
                  alt="Feature Icon"
                />
                <h3>Lightning Fast</h3>
                <p>
                Fully multi-threaded for a blazing fast and reliable experience.
                </p>
              </div>
            </div>
            <div className="col">
              <div className="featureCard">
                <img
                  className="featureIcon"
                  src={featureIcon}
                  alt="Feature Icon"
                />
                <h3>Lightning Fast</h3>
                <p>
                Fully multi-threaded for a blazing fast and reliable experience.
                </p>
              </div>
            </div>
            <div className="col">
              <div className="featureCard">
                <img
                  className="featureIcon"
                  src={featureIcon}
                  alt="Feature Icon"
                />
                <h3>Lightning Fast</h3>
                <p>
                Fully multi-threaded for a blazing fast and reliable experience.
                </p>
              </div>
            </div>
            <div className="col">
              <div className="featureCard">
                <img
                  className="featureIcon"
                  src={featureIcon}
                  alt="Feature Icon"
                />
                <h3>Lightning Fast</h3>
                <p>
                Fully multi-threaded for a blazing fast and reliable experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default Features